module.exports = __webpack_public_path__ + "static/media/push.0cd1df0b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/styles/images/sp/push.svg
// module id = 972
// module chunks = 0